


































































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import Edit from "@/components/TenantSpace/Edit.vue";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { Header } from "@/components/MyTable.vue";

const TableHeaders: Header[] = [
  { title: "名称", key: "name", width: 150 },
  { title: "编码", key: "code" },
  { title: "项目数量", key: "projectCount" },
  { title: "成员数", key: "memberCount" },
  { title: "CPU", key: "", minWidth: 150 },
  { title: "内存", key: "", minWidth: 150 },
  { title: "管理员", key: "adminUsers" },
  { title: "创建时间", key: "createTime", width: 180 },
  { title: "操作", key: "", width: 80 }
];
export default Vue.extend({
  name: "TenantSpace",
  components: { TableLayout, Edit },
  data() {
    return { TableHeaders };
  },
  computed: {
    ...mapState("TenantSpace", [
      "pages",
      "pageNum",
      "total",
      "filterValue",
      "loading",
      "hasNext"
    ]),
    ...mapGetters("TenantSpace", ["tableData"])
  },
  mounted() {
    this.ClearStateMutation();
    this.getData();
  },
  methods: {
    ...mapActions("TenantSpace", ["getData", "delete", "search", "turnPage"]),
    ...mapActions("LoginInfo", ["info"]),
    ...mapMutations("TenantSpace", ["ClearStateMutation"]),
    del(id: string, name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete(id).then(() => {
          this.info();
        });
      });
    },
    create(data?: any) {
      (this.$refs.edit as any)?.show(data);
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.id, data.name);
          break;
        case "quota":
          (this.$refs.quota as any)?.show(data);
          break;
      }
    },
    afterEdit() {
      this.search();
      this.info();
    }
  }
});
